import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function igcseBooklist() {
  const tabs = [
  


    { title: 'CAMBRIDGE BOOK LIST', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Cambridge Book List</h1>
    </div>
    {/* <div className='print-booklist'>
    <Link  to="../pdf/Book-list/igcse-booklist/Book List Cam.pdf"
        target="_blank"
        rel="noopener noreferrer"
    > Print Book list </Link>
   </div> */}
    <div className='syllubus-data'>
      
      <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>Grade 9 & 10 - IGCSE yr-1 & 2</th>
        </tr>
         <tr>
          
           <th>S.NO</th>
           <th className='book-width'>Subject Name of Book</th>
           <th>AUTHOR</th>
           <th>ISBN</th>
           <th>Publisher</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>1</td>
           <td>Cambridge IGCSE First language English</td>
           <td>Julia Burchell</td>
           <td>9780008262006</td>
           <td>Collins</td>
         </tr>
         <tr>
           <td>2</td>
           <td>Cambridge IGCSE First language English-Work book</td>
           <td>Julia Burchell</td>
           <td>9780008262020</td>
           <td>Collins</td>
         </tr>
         <tr>
           <td>3</td>
           <td>Cambridge IGCSE Physics 4th Hodder Education</td>
           <td>Heather Kennette & Tom Duncan</td>
           <td>9781398310544</td>
           <td>Hodder Education</td>
         </tr>
         <tr>
           <td>4</td>
           <td>Cambridge IGCSE Chemistry 4th</td>
           <td>Earl and Wilson</td>
           <td>9781398310506</td>
           <td>Hodder Education</td>
         </tr>
         <tr>
           <td>5</td>
           <td>Biology for Cambridge IGCSE Cambridge</td>
           <td>Marry Jones and Geoff Jones</td>
           <td>9781108936767</td>
           <td>Cambridge University Press</td>
         </tr>
         <tr>
           <td>6</td>
           <td>Complete Mathematics for Cambridge IGCSE 5th edition</td>
           <td>David Ryner, Ian Bettison, Mathew Taylor</td>
           <td>9781382042529</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>7</td>
           <td>Cambridge IGCSE ICT 3rd  Edition</td>
           <td>Brian Sargent, David Watson </td>
           <td>9781398318540</td>
           <td>Hodder</td>
         </tr>
         <tr>
           <td>8</td>
           <td>Cambridge IGCSE O level Business </td>
           <td>Karen Borrington and Peter stimpson-6th edition</td>
           <td>9781036010645</td>
           <td>Hodder</td>
         </tr>
         <tr>
           <td>9</td>
           <td>Cambridge IGCSE O level Business (workbook)</td>
           <td>Karen Borrington and Peter stimpson- 3rd h  edition</td>
           <td>9781036010720  </td>
           <td>Hodder</td>
         </tr>
         <tr>
           <td>10</td>
           <td>Cambridge IGCSE  Economics Course book</td>
           <td>James Bure, Karen Borringlon, Clive Riches</td>
           <td>9780008254094</td>
           <td>Collins</td>
         </tr>
         <tr>
           <td>11</td>
           <td>Cambridge IGCSE & O level Environmental Management-Course book</td>
           <td>Gary Skinner,Ken Crafter, Ann Skinner, Melissa Turner and John Stacy</td>
           <td>9780100989009</td>
           <td>Cambridge University</td>
         </tr>
         <tr>
           <td>12</td>
           <td>Cambridge IGCSE & O level Global Perspective-Coursebook</td>
           <td>Keely Laylock</td>
           <td>9781316611104</td>
           <td>Cambridge</td>
         </tr>
      
         <tr>
           <td>13</td>
           <td>Tricolor-4 5e Edition (French Course Book)
Cambridge IGCSE Reading & Listening Skills
</td>
           <td>Heather Mascie Sylvia Honner</td>
           <td>9780198374756</td>
           <td>Oxford 
Hodder Education 
</td>
         </tr>
         <tr>
           <td>14</td>
           <td>Tricolor-4 5e Edition (French Work Book)</td>
           <td>Andrew Loughe&JaneMensfield</td>
           <td>9780198412076</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>15</td>
           <td>Patvaar-2 Sanskaran kaksha-9 – Vaachan va  Lekhan</td>
           <td>Sandeep Patil</td>
           <td>9781666413472</td>
           <td>Suvarna Sandeep Patil</td>
         </tr>
         <tr>
           <td>16</td>
           <td>Patvar-2 prashanpatra-2, Shravan </td>
           <td>Sandeep Patil</td>
           <td>9781666413489</td>
           <td>Suvarna Sandeep Patil</td>
         </tr>
         <tr>
          <td>17</td>
           <td>Patvar-2 Sanskaran-kaksha-10, Vaachan va lekhan</td>
           <td>Sandeep Patil </td>
           <td> </td>
           <td>Suvarna Sandeep Patil</td>
         </tr>
         <tr>
          <td>18</td>
           <td>Patvar-2 Sanskaran kaksha-10, Prashan Patra-2 Shravan</td>
           <td>Sandeep Patil</td>
           <td></td>
           <td>Suvarna Sandeep Patil</td>
         </tr>
        
        </tbody>
             </table>
             <br></br>
     <table>
       <thead>
        <tr>
          <th colSpan={5}>GRADE 8 - CAMBRIDGE LOWER SECONDARY STAGE 9 (Class 8)</th>
        </tr>
         <tr>
          
           <th>S.NO</th>
           <th className='book-width'>Subject Name of Book</th>
           <th>Author(s)</th>
           <th>ISBN</th>
           <th>Publisher</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>1</td>
           <td>Cambrdige Lower Secondary English</td>
           <td>Julia Bruchell and Mike Gould</td>
           <td>9780008364083</td>
           <td>COLLINS</td>
         </tr>
         <tr>
           <td>2</td>
           <td>Cambridge Lower
Secondary complete
Physic, Biology and
Chemistry</td>
           <td>CBio- Ann Fullick, Anna
,Harris, Yao Jin Choong
Phy – Helen Reylonds, Anna
Harris Elliot Ann May Ling
Chemistry – Philippa Gardon
Hulme, Anna Harris</td>
           <td>978-1-382-0190, 
978-1-382-01834, 
978-1-382-01848-7</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>3</td>
           <td>Cambridge Mathematics
Course Book Stage 9</td>
           <td>Greg Byrd, Lymm Byrd </td>
           <td>9781108783774</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>4</td>
           <td>Cambridge Mathematics
Workbook Stage 9</td>
           <td>Greg Byrd,Lymm Byrd</td>
           <td>9781108746502</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>5</td>
           <td>The Trail-History &amp;
Civics for Grade 8</td>
           <td>Jayanti Sengupta</td>
           <td>978-0-19-0121501</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>6</td>
           <td>Interactions-Nelson Key
Geography</td>
           <td>David Waugh and Tonu
Bushell</td>
           <td>9780199129652</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>7</td>
           <td>COMPUTING-9</td>
           <td>SERIES EDITOR- Lorne

Pearcey </td>
           <td>978-1-3983-69825</td>
           <td>Hodder</td>
         </tr>
         <tr>
           <td>8</td>
           <td>Tricolor-3</td>
           <td>Heather Mascie-Taylor</td>
           <td></td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>9</td>
           <td>Pragyan- 8 </td>
           <td>Vidhya Upadhyay</td>
           <td></td>
           <td>Vishnubhoot</td>
         </tr>
         <tr>
           <td>10</td>
           <td>Well Being</td>
           <td>Louis Aukland</td>
           <td>978138204052-5</td>
           <td>OXford</td>
         </tr>
     
   
        
       
      
      
       
        </tbody>
             </table>
             <br></br>
             {/* <p>** CALCULATOR-GDC (CASIO SCIENTIFIC GRAPHIC CALCULATOR FX CG50)</p> */}
<br></br>
<table>
       <thead>
        <tr>
          <th colSpan={5}>CAMBRIDGE LOWER SECONDRY STAGE 8 (Class 7)</th>
        </tr>
         <tr>
          
           <th>S.NO</th>
           <th className='book-width'>Subject Name of Book</th>
           <th>Author(s)</th>
           <th>ISBN</th>
           <th>Publisher</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>1</td>
           <td>Cambrdige Lower
Secondary
2 nd edition English </td>
           <td>MLucy Brichenough,Julia Bruchell,
Clare, Mike Naomi, Ian,Emma</td>
           <td>9780008364083</td>
           <td>COLLINS</td>
         </tr>
         <tr>
           <td>2</td>
           <td>Cambridge Lower
Secondary complete
Physic, Biology and
Chemistry</td>
           <td>Bio- Ann Fullick, Anna ,Harris, Yao
Jin Choong
Phy – Helen Reylonds, Anna Harris
Elliot Ann May Ling
Chemistry – Philippa Gardon Hulme,
Anna Harris</td>
           <td>978-1-382-0190,
978-1-382-01834,
978-1-382-01848-7</td>
           <td>OXFORD</td>
         </tr>
         <tr>
           <td>3</td>
           <td>Cambridge
Mathematics Course
Book Stage 8</td>
           <td>Greg Byrd, Lymm Byrd</td>
           <td>9781108771528</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>4</td>
           <td>Cambridge
Mathematics Workbook
Stage 8</td>
           <td>Greg Byrd,Lymm Byrd</td>
           <td>9781108746403</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>5</td>
           <td>The Trail-History &amp;
Civics for Grade 7</td>
           <td>Jayanti Sengupta</td>
           <td>9780190121495</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>6</td>
           <td>Connection - Nelson Key
Geography </td>
           <td>David Waugh and Tony Bushell</td>
           <td>9780199129645</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>7</td>
           <td>COMPUTING -8</td>
           <td>SERIES EDITOR: Loren Pearcy</td>
           <td>978-1-3983-6979-5</td>
           <td>Hodder Education</td>
         </tr>
         <tr>
           <td>8</td>
           <td>Tricolor-2</td>
           <td>Heather Mascie-Taylor</td>
           <td></td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>9</td>
           <td>Pragyan-7</td>
           <td>Vidhya Upadhyay</td>
           <td></td>
           <td>Vishnubhoot</td>
         </tr>
         <tr>
           <td>10</td>
           <td>Well Being</td>
           <td>Adrian Bethune</td>
           <td>978-1-382-04051-8</td>
           <td>Oxford</td>
         </tr>
 
        
       
      
      
       
        </tbody>
             </table>
             <br></br>
             {/* <p>** CALCULATOR-GDC (CASIO SCIENTIFIC GRAPHIC CALCULATOR FX CG50)</p> */}
             <br></br>
             <table>
       <thead>
        <tr>
          <th colSpan={5}>CAMBRIDGE LOWER SECONDRY STAGE 7 (Class 6)</th>
        </tr>
         <tr>
          
           <th>S.NO</th>
           <th className='book-width'>Subject Name of Book</th>
           <th>Author(s)</th>
           <th>ISBN</th>
           <th>Publisher</th>
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td>1</td>
           <td>Cambrdige Lower Secondary
2 nd edition English </td>
           <td>Lucy Birchenough,
Julia Burchell, Clare, Mike,
Naomi, Ian, Emma</td>
           <td>9780008340834</td>
           <td>COLLINS</td>
         </tr>
         <tr>
           <td>2</td>
           <td>Cambridge Lower Secondary
complete Physic, Biology and
Chemistry</td>
           <td>Bio- Ann Fullick, Anna Harris,
Yao Jin Choong
Phy – Helen Reylonds, Anna
Harris Elliot Ann May Ling
Chemistry – Philippa Gardon
Hulme, Anna Harris</td>
           <td>978-1-382-019019,
978-1-382-018340,
978-1-382-01848-7</td>
           <td>OXFORD</td>
         </tr>
         <tr>
           <td>3</td>
           <td>Cambridge Checkpoint
Mathematics Course Book
Stage 7 </td>
           <td>Greg Byrd, Lymm Byrd</td>
           <td>9781108771436</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>4</td>
           <td>Cambridge Checkpoint
Mathematics Workbook
Stage 7 </td>
           <td>Greg Byrd,Lymm Byrd </td>
           <td>9781108746366</td>
           <td>Cambridge</td>
         </tr>
         <tr>
           <td>5</td>
           <td>Nelson Key geography
Foundation </td>
           <td>David Waugh, Tony Bushell</td>
           <td>9780199129638</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>6</td>
           <td>The Trail-History &amp; Civics
for Grade 6  </td>
           <td>Jayanti Sengupta</td>
           <td>9780190121488</td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>7</td>
           <td>COMPUTING -7 </td>
           <td>SERIES EDITOR: Loren

Pearcy</td>
           <td>978-1-3983-6932-0</td>
           <td>Hodder

education</td>
         </tr>
         <tr>
           <td>8</td>
           <td>Tricolor-1</td>
           <td>Heather Marcie-Taylor</td>
           <td></td>
           <td>Oxford</td>
         </tr>
         <tr>
           <td>9</td>
           <td>Pragyaan -6</td>
           <td>Vidhya Upadhyay</td>
           <td></td>
           <td>Vishnubhoot</td>
         </tr>
         <tr>
           <td>10</td>
           <td>Well Being</td>
           <td>Louise Aukland</td>
           <td>9781-382-0361707</td>
           <td>Oxford</td>
         </tr>
  
   
        
       
      
      
       
        </tbody>
             </table>
             <br></br>
           
             </div> 
    </div>

    </div> },


  
  ];
  return (
    <div>
      
<div className='ibdp-hero-sec'>
        <img src='newimg/Screenshot_24.webp'/>

      </div>
   
      <div className='ib-syllabus  '>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default igcseBooklist
